<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow title="待办详情" @click-left="onClickLeft">
      <template slot="right" >
        <van-popover v-model="showPopover" trigger="click" :actions="actions" :offset="offset"
                     @select="onSelect" placement="bottom-end">
          <template slot="reference">
            <van-icon name="apps-o" size="18"/>
          </template>
        </van-popover>
      </template>
    </van-nav-bar>
    <van-cell title="申请人">
      <template slot="default">
        <span>{{ this.flowDetail.name }}</span>
      </template>
    </van-cell>
    <van-cell title="申请时间">
      <template slot="default">
        <span>{{ this.flowDetail.createTime }}</span>
      </template>
    </van-cell>
    <van-cell title="请假类型">
      <template slot="default">
        <span>{{ this.flowDetail.ruleName }}</span>
      </template>
    </van-cell>
    <van-cell title="开始时间">
      <template slot="default">
        <span>{{ this.flowDetail.beginTime }}</span>
      </template>
    </van-cell>
    <van-cell title="结束时间">
      <template slot="default">
        <span>{{ this.flowDetail.endTime }}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
import {isWechat} from "../../utils/util";

export default {
  name: "FlowDetail",
  data() {
    return {
      flowDetail: {},
      taskId: '',
      processInstanceId: '',
      flowAppNo: '',
      processDefinitionKey: '',
      showPopover: false,
      actions: [
        {text: '待办处理', value: 1, icon: 'records'},
        // {text: '批注信息', value: 2, icon: 'edit'},
        // {text: '流程信息', value: 3, icon: 'clock-o'},
      ],
      offset: [15, 0],
    };
  },
  created() {
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.flowAppNo = this.$route.query.flowAppNo;
    this.processDefinitionKey = this.$route.query.processDefinitionKey;
    this.taskId = this.$route.query.taskId;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.getAttenceFlowDetail();
  },
  methods: {
    getAttenceFlowDetail: function () {
      let url = "/attence-api/blade-holiday-leave/holidayleave/flowDetailByFlowAppNo";
      this.$fetch(url, {
        flowAppNo: this.flowAppNo,
      }).then(
        res => {
          const data = res.data;
          this.flowDetail = data;
          console.log("返回的数据：" + JSON.stringify(this.flowDetail));
        },
        error => {
        }
      );
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/FlowList",
        query: {}
      });
    },
    onSelect: function (action) {
      if (action.value == 1) {
        this.$router.push({
          path: "/attenceflow/FlowApprove",
          query: {
            taskId: this.taskId,
            processInstanceId: this.processInstanceId,
            businessId: this.businessId,
            processDefinitionKey: this.processDefinitionKey
          }
        });
      } else if (action.value == 2) {
        this.$router.push({
          path: "/attenceflow/FlowComment",
          query: {
            taskId: this.taskId,
            processInstanceId: this.processInstanceId,
            businessId: this.businessId,
            processDefinitionKey: this.processDefinitionKey
          }
        });

      } else if (action.value == 3) {

      }
    },
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/FlowDetail.vue